<button (click)="buttonClick.emit()">
  <mat-icon svgIcon="plus"></mat-icon>
  <ng-content></ng-content>
</button>
